import { render, staticRenderFns } from "./ResourceReport.vue?vue&type=template&id=04f6d2db&scoped=true"
import script from "./ResourceReport.vue?vue&type=script&lang=js"
export * from "./ResourceReport.vue?vue&type=script&lang=js"
import style0 from "./ResourceReport.vue?vue&type=style&index=0&id=04f6d2db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f6d2db",
  null
  
)

export default component.exports